<template>
    <div class="form template-data-container col-6">
        <div class="d-flex flex-column pb-5" v-if="!!client">
            <h4>Información del Cliente: </h4>

            <div class="d-flex flex-column pb-3">
                <h5 class="text-decoration-underline">Datos básicos: </h5>

                <div>
                    <strong>Nombre:</strong> {{ client.name }} {{ client.surname }}
                </div>

                <div v-if="client.dni">
                    <strong>DNI:</strong> {{ client.dni }}
                </div>

                <div v-if="client.nif">
                    <strong>NIF:</strong> {{ client.nif }}
                </div>

                <div>
                    <strong>Nº de Teléfono:</strong> {{ client.phone_number_01 }}
                </div>

                <div>
                    <strong>Nº de Teléfono Alternativo:</strong> {{ client.phone_number_02 }}
                </div>

                <div>
                    <strong>Email:</strong> {{ client.email_01 }}
                </div>

                <div>
                    <strong>Email alternativo:</strong> {{ client.email_02 }}
                </div>
            </div>

            <div class="d-flex flex-column pb-3">
                <h5 class="text-decoration-underline">Dirección: </h5>

                <div>
                    <strong>Dirección:</strong> {{ client.type_road }} {{ client.name_road }}
                </div>

                <div>
                    <span><strong> Número: </strong> {{ client.road_number }} </span>
                    <span><strong> Planta: </strong> {{ client.floor }} </span>
                    <span><strong> Letra: </strong> {{ client.letter }} </span>
                </div>

                <div>
                    <strong> Código postal: </strong> {{ client.postal_code }}
                </div>

                <div>
                    <strong> Comunidad: </strong> {{ client.community }}
                </div>

                <div>
                    <strong> Provincia: </strong> {{ client.province }}
                </div>

                <div>
                    <strong> Ciudad: </strong> {{ client.town }}
                </div>
            </div>
        </div>

        <div class="d-flex flex-column pb-5" v-if="!!selected">
            <h4>Información del destinatario: </h4>

            <div class="d-flex flex-column pb-3">
                <h5 class="text-decoration-underline">Datos básicos: </h5>

                <div>
                    <strong>Nombre:</strong> {{ selected.name }} {{ selected.surname }}
                </div>

                <div v-if="selected.dni">
                    <strong>DNI:</strong> {{ selected.dni }}
                </div>

                <div v-if="selected.nif">
                    <strong>NIF:</strong> {{ selected.nif }}
                </div>

                <div>
                    <strong>Nº de Teléfono:</strong> {{ selected.phone_number_01 }}
                </div>

                <div>
                    <strong>Nº de Teléfono Alternativo:</strong> {{ selected.phone_number_02 }}
                </div>

                <div>
                    <strong>Email:</strong> {{ selected.email_01 }}
                </div>

                <div>
                    <strong>Email alternativo:</strong> {{ selected.email_02 }}
                </div>
            </div>

            <div class="d-flex flex-column pb-3">
                <h5 class="text-decoration-underline">Información de contacto: </h5>

                <div>
                    <strong>Nombre del departamento:</strong> {{ selected.department_name }}
                </div>

                <div>
                    <strong>Nombre del contacto:</strong>
                    {{ selected.customer_service_name }} {{ selected.customer_service_surname }}
                </div>

                <div>
                    <strong>Nº de teléfono del contacto: </strong>
                    {{ selected.customer_service_number_phone }}
                </div>
            </div>

            <div class="d-flex flex-column pb-3">
                <h5 class="text-decoration-underline">Dirección: </h5>

                <div>
                    <strong>Dirección:</strong> {{ selected.type_road }} {{ selected.name_road }}
                </div>

                <div>
                    <span><strong> Número: </strong> {{ selected.road_number }} </span>
                    <span><strong> Planta: </strong> {{ selected.floor }} </span>
                    <span><strong> Letra: </strong> {{ selected.letter }} </span>
                </div>

                <div>
                    <strong> Código postal: </strong> {{ selected.postal_code }}
                </div>

                <div>
                    <strong> Comunidad: </strong> {{ selected.community }}
                </div>

                <div>
                    <strong> Provincia: </strong> {{ selected.province }}
                </div>

                <div>
                    <strong> Ciudad: </strong> {{ selected.town }}
                </div>
            </div>
        </div>
    </div>

    <div class="col-6">
        <div class="form template-data-container col-6 w-auto h-100">
            <h4>Opciones del burofax: </h4>

            <div class="form-group d-flex flex-column">
                <div class="pb-2">
                    <label for="burofax_type">Tipo de envio: </label>
                    <select v-model="burofax_type_selected" class="form-control"
                            @change="updatedValue">
<!--                        1 hace referencia a burofax en Notificados client-->
<!--                        2 hace referencia a comunicacion electronica en Notificados client-->
<!--                        3 hace referencia a burofax y marca es_electronica electronico en Notificados client-->
                        <option value="1">Burofax Postal</option>
                        <option value="3">Burofax Electronico</option>
                        <option value="2">Comunicación electrónica</option>
                    </select>
                </div>

                <div class="pb-2" v-if="['2', '3'].includes(burofax_type_selected)">
                    <label for="email_receiver">Correo del destinatario: </label>
                    <select v-model="email_receiver" class="form-control"
                            @change="updatedValue">
                        <option :value="selected.email_01">{{ selected.email_01 }}</option>
                        <option :value="selected.email_02">{{ selected.email_02 }}</option>
                    </select>
                </div>

                <div class="pb-2">
                    <label for="plazo">Días de plazo: </label>
                    <input class="form-control border" type="number" v-model="plazo"
                           @input="updatedValue"
                           :disabled="!userCanChangeOptions">
                </div>

                <div class="pb-2">
                    <label for="plazo_disponibilidad">Días de plazo de disponibilidad: </label>
                    <input class="form-control border" type="number" v-model="plazo_disponibilidad"
                           :disabled="!userCanChangeOptions" @input="updatedValue">
                </div>

            </div>

            <div class="form-group d-flex flex-column" v-if="userCanChangeOptions">
                <div>
                    <input class="me-3" id="acuse_recibo" type="checkbox" v-model="acuse_recibo" @input="updatedValue">
                    <label for="acuse_recibo">Marca si quieres acuse de recibo. </label>
                </div>

                <div>
                    <input class="me-3" id="copia_certificada" type="checkbox" v-model="copia_certificada"
                           @input="updatedValue">
                    <label for="copia_certificada">Marca si quieres copia certificada. </label>
                </div>

                <div>
                    <input class="me-3" id="copia_testimonial" type="checkbox" v-model="copia_testimonial"
                           @input="updatedValue">
                    <label for="copia_testimonial">Marca si quieres copia testimonial. </label>
                </div>

                <div class="d-inline-flex align-items-start">
                    <input class="mt-1 me-3" id="copia_testimonial_notario" type="checkbox"
                           v-model="copia_testimonial_notario" @input="updatedValue">
                    <label for="copia_testimonial_notario">Marca si quieres copia certificada con testimonio
                        notarial. </label>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {can} from "../../../helpers/Permissions";

export default {
    name: 'BurofaxTemplatePreviewPageSettings',
    props: {
        expedient: {
            type: Object,
            required: true,
        }
    },
    computed: {
        userCanChangeReceiver() {
            return can('burofax.change.receiver');
        },
        userCanChangeOptions() {
            return can('burofax.change.options');
        },
        client() {
            return this.expedient?.clients ? this.expedient.clients[0] : {};
        }
    },
    data() {
        return {
            selected: [this.expedient?.entities] ?? {},
            email_receiver: '',

            type: 'entity',
            burofax_type: '2',
            burofax_type_selected: '2',
            selected_type: 'entity',
            selected_id: 0,
            plazo: 0,
            plazo_disponibilidad: 21,
            es_electronico: true,
            acuse_recibo: true,
            copia_certificada: false,
            copia_testimonial: false,
            copia_testimonial_notario: false,
        }
    },
    mounted() {
        this.selected = this.expedient?.entities ? this.expedient.entities[0] : {};
        this.email_receiver = this.selected.email_01;

        this.updatedValue();
    },
    methods: {
        updatedValue() {
            let burofaxType = this.burofax_type_selected;

            if (this.burofax_type_selected === '1') {
                this.es_electronico = false;
            } else if (this.burofax_type_selected === '3') {
                this.es_electronico = true;
                burofaxType = '1';
            }

            let data = {
                type: this.type,
                selected: this.selected.id,
                email_receiver: this.email_receiver,
                burofax_type: burofaxType,
                plazo: this.plazo,
                plazo_disponibilidad: this.plazo_disponibilidad,
                es_electronico: this.es_electronico,
                acuse_recibo: this.acuse_recibo,
                copia_certificada: this.copia_certificada,
                copia_testimonial: this.copia_testimonial,
                copia_testimonial_notario: this.copia_testimonial_notario,
            }

            this.$emit('updatedSettings', data);
        }
    },
    watch: {
        expedient: function () {
            [this.selected] = this.expedient.entities;
            this.updatedValue();
        },
        selected: function () {
            this.email_receiver = this.selected.email_01;
            this.updatedValue();
        }
    }
}
</script>
